import React, { useState, useMemo } from "react";
import { Zap, Dumbbell, Heart } from "lucide-react";

const QUALITIES = {
  strength: {
    label: "Strength",
    icon: Dumbbell,
    color: "#3b82f6",
    metric: "Powerlifting Squat",
    unit: "kg",
    male: [
      { age: 10, value: 35, pct: 15 },
      { age: 15, value: 100, pct: 42 },
      { age: 20, value: 200, pct: 83 },
      { age: 25, value: 240, pct: 100 },
      { age: 30, value: 235, pct: 98 },
      { age: 35, value: 222, pct: 93 },
      { age: 40, value: 208, pct: 87 },
      { age: 45, value: 192, pct: 80 },
      { age: 50, value: 175, pct: 73 },
      { age: 55, value: 158, pct: 66 },
      { age: 60, value: 140, pct: 58 },
      { age: 65, value: 120, pct: 50 },
      { age: 70, value: 100, pct: 42 },
      { age: 80, value: 68, pct: 28 },
    ],
    female: [
      { age: 10, value: 25, pct: 16 },
      { age: 15, value: 65, pct: 42 },
      { age: 20, value: 125, pct: 81 },
      { age: 25, value: 155, pct: 100 },
      { age: 30, value: 150, pct: 97 },
      { age: 35, value: 140, pct: 90 },
      { age: 40, value: 130, pct: 84 },
      { age: 45, value: 118, pct: 76 },
      { age: 50, value: 105, pct: 68 },
      { age: 55, value: 92, pct: 59 },
      { age: 60, value: 78, pct: 50 },
      { age: 65, value: 65, pct: 42 },
      { age: 70, value: 52, pct: 34 },
      { age: 80, value: 35, pct: 23 },
    ],
  },
  speed: {
    label: "Speed",
    icon: Zap,
    color: "#f59e0b",
    metric: "100m Sprint",
    unit: "s",
    male: [
      { age: 10, value: 13.5, pct: 73 },
      { age: 15, value: 11.0, pct: 89 },
      { age: 20, value: 10.2, pct: 96 },
      { age: 25, value: 9.8, pct: 100 },
      { age: 30, value: 10.0, pct: 98 },
      { age: 35, value: 10.4, pct: 94 },
      { age: 40, value: 10.9, pct: 90 },
      { age: 45, value: 11.4, pct: 86 },
      { age: 50, value: 12.0, pct: 82 },
      { age: 55, value: 12.8, pct: 77 },
      { age: 60, value: 13.6, pct: 72 },
      { age: 65, value: 14.6, pct: 67 },
      { age: 70, value: 15.8, pct: 62 },
      { age: 80, value: 19.0, pct: 52 },
    ],
    female: [
      { age: 10, value: 14.2, pct: 75 },
      { age: 15, value: 11.8, pct: 91 },
      { age: 20, value: 11.0, pct: 97 },
      { age: 25, value: 10.7, pct: 100 },
      { age: 30, value: 10.9, pct: 98 },
      { age: 35, value: 11.4, pct: 94 },
      { age: 40, value: 12.0, pct: 89 },
      { age: 45, value: 12.7, pct: 84 },
      { age: 50, value: 13.5, pct: 79 },
      { age: 55, value: 14.4, pct: 74 },
      { age: 60, value: 15.5, pct: 69 },
      { age: 65, value: 16.8, pct: 64 },
      { age: 70, value: 18.2, pct: 59 },
      { age: 80, value: 22.0, pct: 49 },
    ],
  },
  stamina: {
    label: "Stamina",
    icon: Heart,
    color: "#10b981",
    metric: "VO2max",
    unit: "ml/kg/min",
    male: [
      { age: 10, value: 45, pct: 75 },
      { age: 15, value: 52, pct: 87 },
      { age: 20, value: 57, pct: 95 },
      { age: 25, value: 60, pct: 100 },
      { age: 30, value: 58, pct: 97 },
      { age: 35, value: 55, pct: 92 },
      { age: 40, value: 52, pct: 87 },
      { age: 45, value: 49, pct: 82 },
      { age: 50, value: 46, pct: 77 },
      { age: 55, value: 43, pct: 72 },
      { age: 60, value: 40, pct: 67 },
      { age: 65, value: 37, pct: 62 },
      { age: 70, value: 34, pct: 57 },
      { age: 80, value: 26, pct: 43 },
    ],
    female: [
      { age: 10, value: 38, pct: 76 },
      { age: 15, value: 42, pct: 84 },
      { age: 20, value: 47, pct: 94 },
      { age: 25, value: 50, pct: 100 },
      { age: 30, value: 48, pct: 96 },
      { age: 35, value: 46, pct: 92 },
      { age: 40, value: 43, pct: 86 },
      { age: 45, value: 40, pct: 80 },
      { age: 50, value: 37, pct: 74 },
      { age: 55, value: 34, pct: 68 },
      { age: 60, value: 31, pct: 62 },
      { age: 65, value: 28, pct: 56 },
      { age: 70, value: 25, pct: 50 },
      { age: 80, value: 19, pct: 38 },
    ],
  },
};

const UNTRAINED_MULT = {
  10: 1, 15: 1, 20: 1, 25: 1, 30: 0.93, 35: 0.82, 40: 0.72,
  45: 0.62, 50: 0.52, 55: 0.44, 60: 0.37, 65: 0.30, 70: 0.24, 80: 0.16,
};

// SVG coordinate helpers — plot area only (no axis labels in SVG)
const W = 820, H = 350;
const M = { top: 10, right: 10, bottom: 10, left: 10 };
const PW = W - M.left - M.right;
const PH = H - M.top - M.bottom;

const ageToX = (age) => M.left + ((age - 10) / 70) * PW;
const pctToY = (pct) => M.top + ((100 - pct) / 100) * PH;

const buildPath = (points) =>
  points.map((p, i) => `${i === 0 ? "M" : "L"}${ageToX(p.age).toFixed(1)},${pctToY(p.pct).toFixed(1)}`).join(" ");

const xAges = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80];
const yLabels = [0, 25, 50, 75, 100];

const AthleticLifespanChart = () => {
  const [quality, setQuality] = useState("strength");
  const [gender, setGender] = useState("male");
  const [hoverIdx, setHoverIdx] = useState(null);

  const q = QUALITIES[quality];
  const data = q[gender];
  const color = q.color;

  const untrainedData = useMemo(() =>
    data.map((d) => ({ age: d.age, pct: Math.round(d.pct * (UNTRAINED_MULT[d.age] ?? 1)) })),
    [data]
  );

  const trainedPath = buildPath(data);
  const untrainedPath = buildPath(untrainedData);

  const gapArea = useMemo(() => {
    const top = data.map((d) => `${ageToX(d.age).toFixed(1)},${pctToY(d.pct).toFixed(1)}`).join(" L");
    const bot = [...untrainedData].reverse().map((d) => `${ageToX(d.age).toFixed(1)},${pctToY(d.pct).toFixed(1)}`).join(" L");
    return `M${top} L${bot} Z`;
  }, [data, untrainedData]);

  const trainedArea = useMemo(() => {
    const line = data.map((d) => `${ageToX(d.age).toFixed(1)},${pctToY(d.pct).toFixed(1)}`).join(" L");
    return `M${line} L${ageToX(80).toFixed(1)},${pctToY(0).toFixed(1)} L${ageToX(10).toFixed(1)},${pctToY(0).toFixed(1)} Z`;
  }, [data]);

  return (
    <div data-testid="lifespan-chart">
      {/* Tabs */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex gap-2" data-testid="quality-tabs">
          {Object.entries(QUALITIES).map(([key, val]) => {
            const Icon = val.icon;
            const active = quality === key;
            return (
              <button key={key} onClick={() => { setQuality(key); setHoverIdx(null); }}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all border ${active ? "text-white border-white/20" : "text-white/50 border-transparent hover:text-white/80 hover:border-white/10"}`}
                style={active ? { backgroundColor: `${val.color}20`, borderColor: `${val.color}50`, color: val.color } : {}}
                data-testid={`quality-tab-${key}`}>
                <Icon className="w-4 h-4" /> {val.label}
              </button>
            );
          })}
        </div>
        <div className="flex gap-1 bg-white/5 rounded-lg p-1" data-testid="gender-tabs">
          {["male", "female"].map((g) => (
            <button key={g} onClick={() => { setGender(g); setHoverIdx(null); }}
              className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${gender === g ? "bg-white/15 text-white" : "text-white/50 hover:text-white/80"}`}
              data-testid={`gender-tab-${g}`}>
              {g === "male" ? "Male" : "Female"}
            </button>
          ))}
        </div>
      </div>

      {/* Chart box */}
      <div className="bg-[#0B0F1A] border border-white/10 rounded-2xl p-4 md:p-6">
        <div className="flex gap-2">
          {/* Y-axis label + tick values */}
          <div className="flex flex-col items-end shrink-0 justify-between" style={{ paddingTop: 4, paddingBottom: 4 }}>
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-bold text-white">100%</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-bold text-white/70">75%</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-bold text-white/70">50%</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-bold text-white/70">25%</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-bold text-white/50">0%</span>
            </div>
          </div>

          {/* SVG plot area */}
          <div className="flex-1 min-w-0">
            <svg viewBox={`0 0 ${W} ${H}`} className="w-full" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
              {/* Grid lines */}
              {yLabels.map((pct) => (
                <line key={`g-${pct}`} x1={M.left} y1={pctToY(pct)} x2={W - M.right} y2={pctToY(pct)} stroke="white" strokeOpacity="0.08" strokeWidth="1" />
              ))}
              {/* Bottom axis line */}
              <line x1={M.left} y1={pctToY(0)} x2={W - M.right} y2={pctToY(0)} stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />

              {/* Gap fill */}
              <path d={gapArea} fill={color} fillOpacity="0.1" />
              {/* Trained fill */}
              <path d={trainedArea} fill={color} fillOpacity="0.06" />

              {/* Untrained curve */}
              <path d={untrainedPath} fill="none" stroke="#ef4444" strokeWidth="2.5" strokeDasharray="8,6" strokeOpacity="0.5" />
              {/* Trained curve */}
              <path d={trainedPath} fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />

              {/* Data points */}
              {data.map((d, i) => {
                const cx = ageToX(d.age);
                const cy = pctToY(d.pct);
                const hovered = hoverIdx === i;
                const prime = d.pct === 100;
                return (
                  <g key={i} onMouseEnter={() => setHoverIdx(i)} onMouseLeave={() => setHoverIdx(null)}
                    onClick={() => setHoverIdx(hoverIdx === i ? null : i)} className="cursor-pointer">
                    <circle cx={cx} cy={cy} r="16" fill="transparent" />
                    <circle cx={cx} cy={cy} r={hovered ? 7 : prime ? 6 : 4}
                      fill={prime || hovered ? color : "#1E293B"} stroke={color} strokeWidth={hovered ? 3 : 2} />
                    {prime && !hovered && (
                      <text x={cx} y={cy - 14} textAnchor="middle" fill="white" fontSize="11" fontWeight="bold" fontFamily="system-ui">PRIME</text>
                    )}
                    {hovered && (
                      <g>
                        <line x1={cx} y1={cy - 10} x2={cx} y2={cy - 28} stroke={color} strokeWidth="1" strokeOpacity="0.6" />
                        <rect x={cx - 72} y={cy - 72} width="144" height="42" rx="8" fill="#0F172A" stroke={color} strokeWidth="1" strokeOpacity="0.5" />
                        <text x={cx} y={cy - 55} textAnchor="middle" fill="white" fontSize="11" fontWeight="bold" fontFamily="system-ui">
                          Age {d.age} — {d.pct}% of peak
                        </text>
                        <text x={cx} y={cy - 39} textAnchor="middle" fill={color} fontSize="12" fontWeight="bold" fontFamily="system-ui">
                          {q.metric}: {d.value}{q.unit}
                        </text>
                      </g>
                    )}
                  </g>
                );
              })}

              {/* THE GAP label */}
              {(() => {
                const pt = data.find((d) => d.age === 55);
                const upt = untrainedData.find((d) => d.age === 55);
                if (!pt || !upt) return null;
                const my = (pctToY(pt.pct) + pctToY(upt.pct)) / 2;
                return (
                  <g>
                    <text x={ageToX(55)} y={my - 6} textAnchor="middle" fill={color} fontSize="10" fontWeight="bold" fillOpacity="0.9">THE GAP</text>
                    <text x={ageToX(55)} y={my + 6} textAnchor="middle" fill="white" fontSize="9" fillOpacity="0.5">What training preserves</text>
                  </g>
                );
              })()}

              {/* Tick marks for x-axis */}
              {xAges.map((age) => (
                <line key={`t-${age}`} x1={ageToX(age)} y1={pctToY(0)} x2={ageToX(age)} y2={pctToY(0) + 6} stroke="white" strokeOpacity="0.25" strokeWidth="1" />
              ))}
            </svg>

            {/* HTML age labels below SVG */}
            <div className="flex justify-between mt-1 px-[1%]">
              {xAges.map((age) => (
                <span key={age} className="text-[11px] sm:text-xs font-bold text-white/90 text-center w-0 flex justify-center">{age}</span>
              ))}
            </div>
            <p className="text-center text-[11px] font-semibold text-white/50 mt-1.5 tracking-widest uppercase">Age (years)</p>
          </div>
        </div>

        {/* Y-axis title */}
        <p className="text-[11px] font-semibold text-white/50 tracking-widest uppercase mt-1 ml-8">Physical Capability (%)</p>

        {/* Legend */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-4 pt-4 border-t border-white/5">
          <div className="flex items-center gap-2">
            <div className="w-6 h-[3px] rounded" style={{ backgroundColor: color }} />
            <span className="text-xs text-white/80">With Structured Training</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 border-t-[3px] border-dashed border-red-500/60" />
            <span className="text-xs text-white/80">Without Structured Training</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: color }} />
            <span className="text-xs text-white/80">Olympic Masters Standards ({gender === "male" ? "M" : "F"})</span>
          </div>
        </div>
      </div>

      {/* Info bar */}
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1 mt-3 text-sm text-white/60">
        <span>Metric: <span className="font-semibold text-white/90">{q.metric}</span></span>
        <span>Unit: <span className="font-semibold text-white/90">{q.unit}</span></span>
        <span>Gender: <span className="font-semibold text-white/90">{gender === "male" ? "Male" : "Female"}</span></span>
        <span className="text-white/40">Hover or tap points for details</span>
      </div>
    </div>
  );
};

export default AthleticLifespanChart;
